import { Component, OnInit } from "@angular/core";
import {
  StorageUtil,
  Observable,
  Store,
  AppFields,
  take,
  AppTypes,
} from "../../../store";
import { AppState } from "../../../store";
import * as lodash from "lodash";
import { FormGroup } from "@angular/forms";
import { EvaluationsService } from "../../../services/evaluations.service";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { AlertService } from "../../../services/alert.service";
import { Router } from "@angular/router";
import { ClubTeamsService } from "../../../services/club-teams.service";

@Component({
  selector: "app-club-evaluation-players",
  templateUrl: "./club-evaluation-players.component.html",
  styleUrls: ["./club-evaluation-players.component.css"],
})
export class ClubEvaluationPlayersComponent implements OnInit {
  filter = null;
  status = 0;

  itemsPerPage = 50;
  p: number;

  public reverse = false;
  public sortValue = "name"; // Default Sorting Value

  birthYears = [];
  public selectedPlayerRecordIndex = [];
  public isSelectAllCheckBox = false;

  public updateTemplateID: number;

  controls: any[] = [
    { name: "firstName", type: "text", title: "First Name" },
    { name: "lastName", type: "text", title: "Last Name" },
    {
      name: "gender",
      type: "select",
      title: "Gender",
      options: [
        { text: "Male", value: "m" },
        { text: "Female", value: "f" },
      ],
    },
    { name: "dob", type: "date", title: "DOB" },
    { name: "age", type: "number", title: "Age" },
    { name: "avgScore", type: "number", title: "Average Score" },
    {
      name: "playerType",
      type: "select",
      title: "Player Type",
      options: [
        { text: "First Team Player", value: "First Team Player" },
        { text: "Guest Player", value: "Guest Player" },
      ],
    },
    {
      name: "position",
      type: "select",
      title: "Position",
      options: [],
    },
    {
      name: "teamName",
      type: "select",
      title: "Team Name",
      options: [],
    },
    {
      name: "evalStatus",
      type: "select",
      title: "Evaluation Status",
      options: [
        { text: "None", value: "none" },
        { text: "Not Started", value: "not-started" },
        { text: "In Progress", value: "in-progress" },
        { text: "Completed", value: "completed" },
      ],
    },
    {
      name: "evaluatorID",
      type: "select",
      title: "Evaluator Name",
      options: [],
    },
  ];

  searchOpened: boolean;
  assignEvaluation: boolean;
  assignEvaluationSelected: boolean;
  showPlayerEvaluations: boolean;

  isOpenConfirmDeletePopup: boolean;
  isConfirmWarning: boolean;
  evaluationNameToBeDeleted = "";
  alphaNumericPattern = /^[a-zA-Z ]+$/;

  assignEvaluationForm: FormGroup;
  // assignEvaluationSelectedForm: FormGroup;

  clubID: number;
  userID: number;

  allEvaluations: any[];
  allEvaluationsCopy: any[];

  allEvaluationPlayers: any[];
  allEvaluationPLayersCopy: any[];

  allPlayerEvaluations: any;

  selectedBirthYears: any;
  numberOfSelectedPlayers = 0;

  templatesAndEvaluators: any;
  allEvaluators: any;
  allTemplates: any;
  allTeams: any;
  allTeamsCopy: any;

  //Main Page
  allPlayers: any;
  allPlayersCopy: any;
  allPlayersStats: any;

  allStaffMembers: any;

  public teamFields: Object = { text: "teamName", value: "teamID" };
  public evaluatorFields: Object = { text: "evaluatorFullName", value: "evaluatorID" };

  public mode: string;
  public placeholder = "Choose One Or Multiple";
  public isChange: boolean = false;
  public selectedTeamRecordIndex = [];

  payload: any = {
    clubID: null,
    name: "",
    type: null,
    gender: "",
    birthYears: "",
    addedBy: "",
  };

  assignEvaluationFormPayload: any = {
    clubID: 0,
    playerIDs: [],
    evaluationTemplateID: "",
    evaluatorID: "",
  };

  assignEvaluationFilterFormPayload: any = {
    clubID: null,
    evaluationTemplateID: "",
    evaluatorID: "",
    evaluationAssignmentType: "byteam",
    playerGender: "b",
    assignEvaluator: "headcoach",
    playerBirthYears: [],
    playerTeamIDs: [],
  };
  openendPrint: boolean
  positions: Observable<any[]>;
  searchValue: any = {};

  constructor(
    private store: Store<AppState>,
    private _service: EvaluationsService,
    private _clubTeamService: ClubTeamsService,
    private _loadingService: Ng4LoadingSpinnerService,
    private _alertService: AlertService,
    private _router: Router
  ) {
    this.mode = "CheckBox";
    this.isChange = false;

    for (let i = 0; i < 14; i++) {
      this.birthYears.push({ year: 2004 + i, checked: false });
    }

    this.clubID = +localStorage.getItem("clubId");
    this.userID = +localStorage.getItem("userId");

    this.positions = this.store.select(
      AppFields.App,
      AppFields.PlayerPositions
    );

    this.positions.subscribe((res: any[]) => {
      if (res) {
        var positionsString: any[] = [];
        for (let i = 0; i < res.length; i++) {
          var obj = {
            text: res[i].description,
            value: res[i].description,
          };
          positionsString.push(obj);
        }
        this.controls[7].options = positionsString;
      }
    });
  }

  onItemSelect(item: any) {
    this.selectedTeamRecordIndex.push(item.itemData.teamID);
    console.log("teamID[]", this.selectedTeamRecordIndex);
  }
  onSelectAll(items: any) {
    this.selectedTeamRecordIndex.push(items.itemData.teamID);
    console.log("teamID[]", this.selectedTeamRecordIndex);
  }
  onRemove(item: any) {
    const index = this.selectedTeamRecordIndex.indexOf(item.itemData.teamID);
    for (let i = 0; i < this.selectedTeamRecordIndex.length; i++) {
      if (index !== -1) {
        this.selectedTeamRecordIndex.splice(index, 1);
      }
      console.log("teamID[]", this.selectedTeamRecordIndex);
    }
  }

  ngOnInit() {
    this.loadStaffMembers(this.clubID);
    this.loadPlayerMembers(this.clubID);

    //Player Position
    this.positions.pipe(take(1)).subscribe(
      (list) =>
        list === null &&
        this.store.dispatch({
          type: AppTypes.GetPlayerPositions,
          payload: {
            clubID: StorageUtil.clubID,
          },
        })
    );
  }

  loadStaffMembers(clubID: number) {
    this._service.getEvaluatorsAndTemplatesForPlayersByClubID(clubID).subscribe(
      (data) => {
        this.templatesAndEvaluators = data;
        this.allEvaluators = lodash.sortBy(
          data.evaluators,
          "evaluatorFullName"
        );
        this.allTemplates = data.templates;
        this.allTeams = data.teams;
        this.allTeamsCopy = data.teams;
        console.log("Flyout Data = ", data);
        this.setTeamsToSeachFlyout(this.allTeams);
        this.setEvaluatorsToSearchFlyout(data.evaluators);
      },
      (error) => {
        this.templatesAndEvaluators = [];
        this.allEvaluators = [];
        this.allTemplates = [];
        this.allTeams = [];
      }
    );
  }

  evaluationGenderSelectionChanged(event) {
    this.allTeams = this.allTeamsCopy;
    var _selectedGender = event.target.value;
    if (_selectedGender != "b") {
      this.allTeams = this.allTeamsCopy.filter(
        (n) => n.teamGender == _selectedGender
      );
    }
    // console.log("----------------------------------------")
    // console.log("FILTERED TEAMS  =>  ", this.allTeams);
    // console.log("----------------------------------------")
  }

  setTeamsToSeachFlyout(allTeams: any) {
    if (allTeams != null) {
      var positionsString: any[] = [];
      for (let i = 0; i < allTeams.length; i++) {
        var obj = {
          text: allTeams[i].teamName,
          value: allTeams[i].teamName,
        };
        positionsString.push(obj);
      }
      this.controls[8].options = positionsString;
    }
  }


  setEvaluatorsToSearchFlyout(allEvaluators) {
    if (allEvaluators != null) {
      var evaluatorsString: any[] = [];
      for (let i = 0; i < allEvaluators.length; i++) {
        var obj = {
          text: allEvaluators[i].evaluatorFullName,
          value: allEvaluators[i].evaluatorID,
        };
        evaluatorsString.push(obj);
      }
      this.controls[10].options = evaluatorsString;
    }
  }

  loadPlayerMembers(clubID: number) {

    this._service.getEvaluationPlayersByClubID(clubID).subscribe(
      (data) => {
        this.allPlayers = data.players;
        this.allPlayersCopy = data.players; //Create a copy of players (for search)
        this.allPlayersStats = data.playerStats;

        this._loadingService.hide();
        this.searchEvaluationsPlayers();
        this.resetFlyouts();
      },
      (error) => {
        this.allPlayers = null;
      }
    );
  }

  evaluationTypeChange(event) {
    this.payload.type = event.target.value;
  }

  get list() {
    return [];
  }

  selectedRecord(i, e) {
    if (e.target.checked) {
      this.selectedPlayerRecordIndex.push(i);
    } else {
      this.selectedPlayerRecordIndex.splice(
        this.selectedPlayerRecordIndex.indexOf(i),
        1
      );
    }
    // For enable status/delete button.
    this.numberOfSelectedPlayers = this.selectedPlayerRecordIndex.length;

    console.log("numberOfSelectedPlayers ==> ", this.numberOfSelectedPlayers);
  }

  selectAllPlayers(e) {
    if (e.target.checked) {
      this.isSelectAllCheckBox = true;
      this.selectedPlayerRecordIndex = [];
      this.selectedPlayerRecordIndex.length = 0;
      this.allPlayers.forEach(player => {
        this.selectedPlayerRecordIndex.push(player.playerID);
      });

      // console.log("selectAllPlayers (if - checked) = ", e.target.checked);
      // console.log("selectedPlayerRecordIndex (playerIds) => ", this.selectedPlayerRecordIndex);

    } else {
      this.isSelectAllCheckBox = false;
      this.assignEvaluationSelected = false;

      this.selectedPlayerRecordIndex = [];
      this.selectedPlayerRecordIndex.length = 0;

      // console.log("selectAllPlayers (else - checked) = ", e.target.checked);
      // console.log("selectedPlayerRecordIndex (playerIds) => ", this.selectedPlayerRecordIndex);
    }

    this.numberOfSelectedPlayers = this.selectedPlayerRecordIndex.length;
    // console.log("numberOfSelectedPlayers (value) = ", this.numberOfSelectedPlayers);
  }


  onAssignSelectedPlayers(event) {
    this.assignEvaluationFormPayload.clubID = this.clubID;
    const selectedPlayers = this.selectedPlayerRecordIndex;
    this.assignEvaluationFormPayload.playerIDs = selectedPlayers;
    console.log(
      "assignEvaluationFormPayload VALUE = ",
      this.assignEvaluationFormPayload
    );
    if (
      this.assignEvaluationFormPayload.evaluationTemplateID === "" ||
      this.assignEvaluationFormPayload.evaluatorID === ""
    ) {
      this._alertService.warn("Please select a template and an evaluator");
    } else {
      this._loadingService.show();
      this._service
        .assignEvaluationTemplateToSelectedPlayers(
          this.assignEvaluationFormPayload
        )
        .subscribe(
          (rs: any) => {
            //this._alertService.success("Evaluation assigned to player(s).");
            //For showing success, warn & error message.
            if (rs.id == 1) {
              this._alertService.success(rs.successMessage);
            }
            if (rs.id == 2) {
              this._alertService.successHigh(rs.successMessage);
              this._alertService.warnHigh(rs.failedMessage);
            }
            if (rs.id == 3) {
              this._alertService.warn(rs.failedMessage);
            }
            this.resetAssignEvaluationFormPayload();
            this.loadPlayerMembers(this.clubID);

          },
          (error) => {
            this._loadingService.hide();
            console.log("ERROR => ", error);
            this._alertService.error("Something went wrong.");
            /*if (error.status === 444) {
              this._alertService.warn(
                "Evalaution is not suitable for the selected Player(s)"
              );
            } else {
              this._alertService.error(error.message);
            }*/
          }
        );
    }
  }
  evaluationSelectedTemplateChanged(event) {
    this.assignEvaluationFormPayload.evaluationTemplateID = event.target.value;
  }

  evaluationSelectedEvaluatorChanged(event) {
    this.assignEvaluationFormPayload.evaluatorID = event.target.value;
  }

  onAssignFilteredPlayers(event) {
    this.assignEvaluationFilterFormPayload.clubID = this.clubID;
    this.assignEvaluationFilterFormPayload.playerTeamIDs = this.selectedTeamRecordIndex;

    this.assignEvaluationFilterFormPayload.playerBirthYears = this.birthYears
      .filter((opt) => opt["checked"])
      .map((opt) => opt.year);

    if (this.assignEvaluationFilterFormPayload.evaluationTemplateID === "") {
      this._alertService.warn("Please, select a template");
    }

    // console.log('this.assignEvaluationFilterFormPayload.assignEvaluator   =>  ', this.assignEvaluationFilterFormPayload.assignEvaluator);
    // console.log('this.assignEvaluationFilterFormPayload.evaluatorID   =>  ', this.assignEvaluationFilterFormPayload.evaluatorID);
    else if (
      this.assignEvaluationFilterFormPayload.assignEvaluator == "choose" &&
      this.assignEvaluationFilterFormPayload.evaluatorID == 0
    ) {
      this._alertService.warn("Please, select an evaluator");
    } else {
      // console.log('PAYLOAD = ', this.assignEvaluationFilterFormPayload);
      if (this.assignEvaluationFilterFormPayload.evaluatorID === "") {
        this.assignEvaluationFilterFormPayload.evaluatorID = 0;
      }

      console.log(
        "EVALUATIONS NEW PAYLOAD ==> ",
        this.assignEvaluationFilterFormPayload
      );

      this._loadingService.show();
      this._service
        .assignEvaluationTemplateToFilteredPlayers(
          this.assignEvaluationFilterFormPayload
        )
        .subscribe(
          (res) => {
            console.log("Data ====================> ", res);

            //For showing success, warn & error message.
            if (res.id == 1) {
              this._alertService.success(res.successMessage);
            }
            if (res.id == 2) {
              this._alertService.successHigh(res.successMessage);
              this._alertService.warnHigh(res.failedMessage);
            }
            if (res.id == 3) {
              this._alertService.warn(res.failedMessage);
            }

            this._loadingService.hide();
            this.resetAssignEvaluationFilterFormPayload();
            this.loadPlayerMembers(this.clubID);

            /*if (res.startsWith("0")) {
              this._alertService.info(res);
            } else {
              this._alertService.success(res);
              this.resetAssignEvaluationFilterFormPayload();
              this.loadPlayerMembers(this.clubID);
            }*/

          },
          (error) => {
            this._loadingService.hide();
            this._alertService.error("Something went wrong.");
            //this._alertService.error("Evaluation could not be assigned");
          }
        );
    }
  }

  evaluationFilterSelectedTemplateChanged(event) {
    this.assignEvaluationFilterFormPayload.evaluationTemplateID =
      event.target.value;
  }

  evaluationFilterSelectedEvaluatorChanged(event) {
    this.assignEvaluationFilterFormPayload.evaluatorID = event.target.value;
  }

  onCancel(event) {
    this.assignEvaluation = false;
    this.assignEvaluationSelected = false;
    this.showPlayerEvaluations = false;
    this.openendPrint = false;
    this.resetAssignEvaluationFormPayload();
    this.resetAssignEvaluationFilterFormPayload();
  }

  addEvaluation(f) {
    //console.log('ADD EVALUATION   ===   ', f);
  }


  setOrder(value: string) {
    this.reverse = !this.reverse;
    this.sortValue = value;
    const players = lodash.sortBy(this.allPlayers, value);
    this.allPlayers = this.reverse ? players.reverse() : players;
  }

  searchEvaluationsPlayers(formData = this.searchValue) {
    this.searchValue = formData;
    this.allPlayers = this.allPlayersCopy;

    if (formData.firstName) {
      this.allPlayers = this.allPlayers.filter((n) =>
        n.fullName.includes(formData.firstName)
      );
    }

    if (formData.lastName) {
      this.allPlayers = this.allPlayers.filter((n) =>
        n.fullName.includes(formData.lastName)
      );
    }

    if (formData.gender) {
      this.allPlayers = this.allPlayers.filter(
        (n) => n.gender === formData.gender
      );
    }

    if (formData.age) {
      this.allPlayers = this.allPlayers.filter((n) => n.age == formData.age);
    }

    if (formData.dob) {
      let dt = new Date(formData.dob);
      let dtString = `${dt.getFullYear()}-${dt.getMonth().toString().length === 1 ? ("0" + (dt.getMonth() + 1).toString()) : dt.getMonth() + 1}-${dt.getDate().toString().length === 1 ? ("0" + dt.getDate().toString()) : dt.getDate()}T00:00:00`;
      this.allPlayers = this.allPlayers.filter(n => n.dob == dtString);
    }

    if (formData.playerType) {
      this.allPlayers = this.allPlayers.filter(
        (n) => n.playerType === formData.playerType
      );
    }

    if (formData.position) {
      this.allPlayers = this.allPlayers.filter(
        (n) => n.position === formData.position
      );
    }

    if (formData.teamName) {
      this.allPlayers = this.allPlayers.filter(
        (n) => n.teamName === formData.teamName
      );
    }

    if (formData.avgScore) {
      this.allPlayers = this.allPlayers.filter(
        (n) => n.avgScore === formData.avgScore
      );
    }

    if (formData.evalStatus) {
      this.allPlayers = this.allPlayers.filter(
        (n) => n.evalStatus === formData.evalStatus
      );
    }


    if (formData.evaluatorID) {
      this.allPlayers = this.allPlayers.filter(
        (n) => n.playerEvaluatorIDs.includes(formData.evaluatorID)
      );
    }


    // console.log("Search (formData) = ", formData);

  }

  filterEvaluationsByStatus(evalStatus: string) {
    console.log("EVAL STATUS = ", evalStatus);

    this.allPlayers = this.allPlayersCopy;

    switch (evalStatus) {
      case "not-started":
        console.log("Not Started Filter");
        this.allPlayers = this.allPlayers.filter(n => n.hasNotStartedEvaluations === true);
        break;
      case "in-progress":
        console.log("In Progress Search");
        this.allPlayers = this.allPlayers.filter(n => n.hasInProgressEvaluations === true);
        break;
      case "completed":
        console.log("Completed Search");
        this.allPlayers = this.allPlayers.filter(n => n.hasCompletedEvaluations === true);
        break;
      default:
        break;
    }

    // if (evalStatus) {
    //   this.allPlayers = this.allPlayers.filter(n =>
    //     n.evalStatus === evalStatus
    //   );
    // } else {

    // }
  }

  closeOverlay(event = null) {
    if (event) {
      event.stopPropagation();
    }
    this.resetAssignEvaluationFormPayload();
    this.resetAssignEvaluationFilterFormPayload();
    this.searchOpened = false;
    this.assignEvaluation = false;
    this.assignEvaluationSelected = false;
    this.showPlayerEvaluations = false;
    this.openendPrint = false;
  }

  onAddEvaluation() {
    this.assignEvaluation = true;
    this.assignEvaluationSelected = false;
    this.showPlayerEvaluations = false;
  }

  onAddEvaluationSelected() {
    this.assignEvaluation = false;
    this.assignEvaluationSelected = true;
    this.showPlayerEvaluations = false;
  }

  private showPlayerEvaluationsSelectedPlayerID = 0;
  onShowPlayerEvaluations(playerID) {
    this.showPlayerEvaluationsSelectedPlayerID = playerID;
    this._loadingService.show();
    this.loadEvaluationsFlyoutByPlayerIdAndClubId(playerID, this.clubID);
  }

  removePlayerEvaluation(userEvaluationID) {
    this._service.removePlayerEvaluationByID(userEvaluationID).subscribe(
      (data) => {
        this._loadingService.hide();
        this.loadPlayerMembers(this.clubID);
        this._alertService.success("Evaluation removed from the player");
      },
      (error) => {
        this._loadingService.hide();
        this._alertService.error("Evaluation could not be removed from player");
      }
    );
  }

  viewPlayerEvaluation(userEvaluationID) {
    this._router.navigate([`/player-info/${this.showPlayerEvaluationsSelectedPlayerID}/evaluation-result/${userEvaluationID}`]);
  }

  loadEvaluationsFlyoutByPlayerIdAndClubId(playerID: number, clubID: number) {
    this._service.loadEvaluationsFlyoutByPlayerIdAndClubId(playerID, clubID).subscribe(
      (result: any) => {
        console.log("EVALUATIONS => ", result.data);
        this.allPlayerEvaluations = result.data;

        this.assignEvaluation = false;
        this.assignEvaluationSelected = false;
        this.showPlayerEvaluations = true;
        this._loadingService.hide();
      },
      (error) => {
        console.log("ERROR => ", error);
        this._loadingService.hide();
        this.resetFlyouts();
        this._alertService.error("Evaluations could not be loaded");
      }
    );
  }

  onSearch() {
    this.searchOpened = true;
  }

  navigateToDetails(id, teamID) {
    StorageUtil.teamId = +teamID;
    // this._router.navigate(["player/" + id + "/dashboard"]);
    this._router.navigate(["player/" + id + "/evaluation-info"]);
  }

  resetOptionalButtons() {
    this.selectedPlayerRecordIndex.length = 0;
    this.numberOfSelectedPlayers = 0;
  }

  resetAssignEvaluationFormPayload() {
    this.assignEvaluationFormPayload.playerIDs = null;
    this.selectedPlayerRecordIndex.length = 0;
    this.assignEvaluationFormPayload.evaluationTemplateID = "";
    this.assignEvaluationFormPayload.evaluatorID = "";
    this.numberOfSelectedPlayers = 0;
    this.selectedBirthYears = 0;
  }

  resetAssignEvaluationFilterFormPayload() {
    this.assignEvaluationFilterFormPayload.clubID = null;
    this.selectedPlayerRecordIndex.length = 0;
    this.selectedTeamRecordIndex.length = 0;
    this.assignEvaluationFilterFormPayload.evaluationTemplateID = "";
    this.assignEvaluationFilterFormPayload.evaluatorID = "";
    this.assignEvaluationFilterFormPayload.playerGender = "";
    this.assignEvaluationFilterFormPayload.playerBirthYears = null;
    this.assignEvaluationFilterFormPayload.playerTeamIDs = null;
  }

  resetFlyouts() {
    this.assignEvaluation = false;
    this.assignEvaluationSelected = false;
    this.showPlayerEvaluations = false;
  }

  onPrint() {
    this.openendPrint = true;
    this.getClubTeamsList();
  }

  isIndividualTeam: boolean = false;
  isIndividualPlayer: boolean = false;

  onPrintType(event) {
    if (event.target.value == 1) {
      this.isIndividualTeam = true;
      this.isIndividualPlayer = false;
    }
    if (event.target.value == 2) {
      this.isIndividualPlayer = true;
      this.isIndividualTeam = false;
    }
  }

  clubTeamList: any[] = [];
  getClubTeamsList() {
    this._loadingService.show();
    this._clubTeamService.getClubTeamsList(+StorageUtil.clubID, 0).subscribe((rs: any) => {
      this.clubTeamList = rs;
      this._loadingService.hide();
    }, () => {
      this._loadingService.hide();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/club-evaluations/players/club-evaluation-players.component.ts